export const SET_DISABLE_SPINNER = 'SET_DISABLE_SPINNER';
export const SET_SECTION_MOUNTED = 'SET_SECTION_MOUNTED';
export const SET_SECTION_VIEWED = 'SET_SECTION_VIEWED';
export const SET_LAZY_LOAD = 'SET_LAZY_LOAD';
export const SET_LITE = 'SET_LITE';
